import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email"]
  static values = {
    lookupUrl: String,
    loginUrl: String
  }

  async check() {
    const email = this.emailTarget.value.trim().toLowerCase()
    if (email.length === 0) return

    try {
      const response = await fetch(`${this.lookupUrlValue}?email=${encodeURIComponent(email)}`, {
        headers: { Accept: "application/json" }
      })
      if (!response.ok) return

      const data = await response.json()
      if (!data.exists) return

      const loginUrl = new URL(this.loginUrlValue, window.location.origin)
      loginUrl.searchParams.set("login", email)
      loginUrl.searchParams.set("existing_email", email)
      window.location.assign(loginUrl.toString())
    } catch (_error) {
    }
  }
}
